module.exports = __webpack_public_path__ + "img/wlm.a84a435b.png";